import useRouter from "@hooks/useRouter"

import { faIcon } from "@utils/faIcon"
import isModKeyPressed from "@utils/isModKeyPressed"

import { EmptyState } from "@molecules"

import styles from "@organisms/ObjectsView/CardsView/CardsViewEdgeStates/CardsViewEdgeStates.module.scss"
import CardsViewSkeletonCard from "@organisms/ObjectsView/CardsView/CardsViewEdgeStates/CardsViewSkeletonCard/CardsViewSkeletonCard"
import useObjectsView from "@organisms/ObjectsView/ObjectsView.context"

import { objectMap } from "@constants/objectMap"

export default function CardsViewEmptyState() {
    const { push } = useRouter()

    const { tabContentName, objectCreateRoute, objectType, isEmptyStateCreateButtonVisible } = useObjectsView()

    // e.g. "All Open Jobs" -> "No open jobs" / "There are no open jobs to display".
    const listName = tabContentName.toLowerCase().replace("all", "").replace("&", "or").trim()

    const onCreateClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        if (isModKeyPressed(event)) {
            window.open(objectCreateRoute, "_blank", "noopener,noreferrer")
        } else {
            push(objectCreateRoute)
        }
    }

    return (
        <div className={styles.base}>
            <div className={styles.graphic}>
                <div className={styles.graphicCard}>
                    <CardsViewSkeletonCard />
                </div>
            </div>
            <EmptyState
                variant="default"
                icon={objectMap[objectType].iconActive}
                title={`No ${listName}`}
                supportText={`There are no ${listName} to display`}
                primaryCTA={
                    isEmptyStateCreateButtonVisible
                        ? {
                              children: "Create",
                              leftIcon: faIcon({ name: "plus", style: "regular" }),
                              onClick: onCreateClick,
                              noDebounce: true,
                          }
                        : undefined
                }
            />
        </div>
    )
}
